<template>
    <div class="page-style" id="id-main-section">
      <div class="desktop-view left-header">
        <div>
          <a class="left-top-company font_6 unselectable" @click="selected_section='main';" href="#" target="_self">{{host.company}}</a>
        </div>
        <div>
          <p class="font_9 unselectable" style="line-height: 1.0em;">
            <span class="left-top-company-description">{{host.description}}</span>
          </p>
          <span class="contacts-container">
            <b class="unselectable">Контакные данные:</b>
            <p class="font_9" style="line-height: 0.75em;">
              <span class="contact-mail">{{host.contact_mail}}</span>
            </p>
            <p class="font_9" style="line-height: 0.75em;">
              <span class="contact-phone">{{host.contact_phone}}</span>
            </p>
          </span>
        </div>
      </div>
      <div>
        <nav aria-label="Site">
          <ul class="font_9 unselectable main-menu">
            <li @click="selected_section='main';" data-data-id="id-main-section">
                <a href="#" target="_self" class="main-menu-link" :class="{'active': selected_section === 'main'}">
                  <p style="text-align: left; line-height: 30px;">Главная</p>
                </a>
            </li>
            <!-- <li @click="selected_section='id-online-record';" data-data-id="id-online-record">
                <a href="#" target="_self" class="main-menu-link" :class="{'active': selected_section === 'id-online-record'}">
                  <p style="text-align: left; line-height: 30px;">Онлайн-запись</p>
                </a>
            </li> -->
            <!-- <li data-direction="ltr" data-listposition="center" data-data-id="id-blog" class="style-k9ixyvcc2repeaterButton" data-state="menu  idle link notMobile" id="comp-k9ixyvb52" data-original-gap-between-text-and-btn="0" aria-hidden="false" style="width: 54px; height: 30px; position: relative; box-sizing: border-box; overflow: visible; display: flex">
              <a data-listposition="center" aria-haspopup="false" href="#" target="_self" id="comp-k9ixyvb52linkElement" class="main-menu-li">
                <p style="text-align: left; line-height: 30px;">Блог</p>
              </a>
            </li> -->
            <!-- <li  data-data-id="id-blog" class="style-k9ixyvcc2repeaterButton">
              <a href="https://client.urikoff.ru" target="_self" class="main-menu-link">
                <p style="text-align: left; line-height: 30px;">Личный кабинет</p>
              </a>
            </li> -->
            <li @click="selected_section='id-payment';" data-data-id="id-payment">
                <a href="#" target="_self" class="main-menu-link" :class="{'active': selected_section === 'id-payment'}">
                  <p style="text-align: left; line-height: 30px;">Оплата услуг</p>
                </a>
            </li>
          </ul>
        </nav>
      </div>
      <template v-if="selected_section==='main'">
        <div class="mc1inlineContent">
            <h1>
              <!-- <span class="cent-company color_15 unselectable">{{host.company}}</span> -->
              <div class="central-logo-block unselectable">
                <div class="central-logo-text-container unselectable">
                  <span class="central-logo-company-name unselectable">Юрикофф</span>
                  <span class="central-logo-company-uslugi unselectable">юридические услуги</span>
                </div>
                <img class="central-logo-img" src="static/logo.svg"/>
              </div>
              <!-- <span class="mobile-only work-24-7">{{host.work24_7_short}}</span> -->
            </h1>
            <p class="under-cent-company">
              <span>С нами просто</span>
            </p>
            <p class="font_9 main-text-container">
              <span class="color_15">{{host.our_goal}}</span>
            </p>
            <div class="main-slider-container">
              <carousel :scrollPerPage="true" :perPageCustom="[[320, 1],[480, 1], [768, 1]]" :autoplayHoverPause="false" :loop="true" :autoplay="true" :autoplayTimeout="3000" :paginationEnabled="false">
                <slide v-for="(imgUrl, index) in host.slide_images" :key="index">
                  <img :src="imgUrl" alt="" class="slide-img">
                </slide>
              </carousel>
            </div>
        </div>
        <div class="how-we-work-container">
          <span class="font_5">Как мы работаем:</span>
        </div>
        <div id="prefix_5w33fv0ac">
          <ul class="work-concept-ul">
            <li class="work-concept-li offering-view draw meet" @click="selected_section='work_section_1';">
              <a href="#" data-data-id="id-main-section" style="text-decoration: none;">
                <div class="Card3456923823--mediaWrapper">
                  <div class="Card3456923823--mediaContainer">
                    <div class="OfferingViewImage503669351--imageWrapper">
                      <div data-offeringviewimage503669351-shape="square" class="OfferingViewImage503669351--root">
                        <div data-hook="offering-view-image" class="OfferingViewImage503669351--clickable" role="img" aria-label="booking" tabindex="0">
                          <img class="grid-image" style="width: 100%; height: 100%" :src="host.img_grid_work_section_1"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Card3456923823--infoContainer">
                    <div data-hook="info-container" data-offeringinfo207476195-alignment="left" data-offeringinfo207476195-stickbuttontobottom="true" class="OfferingInfo207476195--verticalLayout">
                      <div>
                        <div class="OfferingName1487631630--root">
                          <a style="text-align: left;" role="link" tabindex="0" class="borderless unselectable" aria-label="Вводная консультация ">
                            <h3 data-text2347419744-typography="smallTitle" data-hook="tile-title" class="font_3">Вводная консультация </h3>
                          </a>
                        </div>
                      <div data-hook="tile-divider" class="Divider1290317650--root OfferingInfo207476195--divider">
                    </div>
                  <section aria-labelledby="offering-info-aria-section-title" role="group">
                    <span id="offering-info-aria-section-title" style="display: none;">Service Information</span>
                    </section>
                  </div>
                </div>
              </div>
            </a>
          </li>
          <li class="work-concept-li offering-view draw meet" @click="selected_section='work_section_2';">
            <a href="#" data-data-id="id-main-section" style="text-decoration: none;">
              <div class="Card3456923823--mediaWrapper">
                <div class="Card3456923823--mediaContainer">
                  <div class="OfferingViewImage503669351--imageWrapper">
                    <div data-offeringviewimage503669351-shape="square" class="OfferingViewImage503669351--root">
                      <div data-hook="offering-view-image" class="OfferingViewImage503669351--clickable" role="img" aria-label="booking" tabindex="0">
                        <img class="grid-image" style="width: 100%" :src="host.img_grid_work_section_2"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Card3456923823--infoContainer">
                <div data-hook="info-container" data-offeringinfo207476195-alignment="left" data-offeringinfo207476195-stickbuttontobottom="true" class="OfferingInfo207476195--verticalLayout">
                  <div>
                    <div class="OfferingName1487631630--root">
                      <a style="text-align: left" role="link" tabindex="0" class="borderless unselectable" aria-label="Создание личного кабинета клиента ">
                        <h3 data-text2347419744-typography="smallTitle" data-hook="tile-title" class="font_3">Создание личного кабинета клиента </h3>
                        </a>
                      </div>
                    <div data-hook="tile-divider" class="Divider1290317650--root OfferingInfo207476195--divider"></div>
                    <section aria-labelledby="offering-info-aria-section-title" role="group">
                      <span id="offering-info-aria-section-title" style="display: none;">Service Information</span>
                    </section>
                  </div>
                </div>
              </div>
            </a>
          </li>
          <li class="work-concept-li offering-view draw meet" @click="selected_section='work_section_3';">
            <a href="#" data-data-id="id-main-section" style="text-decoration: none;">
              <div class="Card3456923823--mediaWrapper">
                <div class="Card3456923823--mediaContainer">
                  <div class="OfferingViewImage503669351--imageWrapper">
                    <div data-offeringviewimage503669351-shape="square" class="OfferingViewImage503669351--root">
                      <div data-hook="offering-view-image" class="OfferingViewImage503669351--clickable" role="img" aria-label="booking" tabindex="0">
                        <img class="grid-image" style="width: 100%" :src="host.img_grid_work_section_3"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Card3456923823--infoContainer">
                  <div data-hook="info-container" data-offeringinfo207476195-alignment="left" data-offeringinfo207476195-stickbuttontobottom="true" class="OfferingInfo207476195--verticalLayout">
                    <div>
                      <div class="OfferingName1487631630--root">
                        <a style="text-align: left" role="link" tabindex="0" class="borderless unselectable" aria-label="Ваш личный юрист решает Вашу проблему">
                          <h3 data-text2347419744-typography="smallTitle" data-hook="tile-title" class="font_3">Ваш личный юрист решает Вашу проблему</h3>
                        </a>
                      </div>
                      <div data-hook="tile-divider" class="Divider1290317650--root OfferingInfo207476195--divider"></div>
                      <section aria-labelledby="offering-info-aria-section-title" role="group">
                        <span id="offering-info-aria-section-title" style="display: none;">Service Information</span>
                      </section>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <span class="mobile-only contacts-container">
          <b class="unselectable">Контакные данные:</b>
          <p class="font_9" style="line-height: 0.75em;">
            <span class="contact-mail">{{host.contact_mail}}</span>
          </p>
          <p class="font_9" style="line-height: 0.75em;">
            <span class="contact-phone">{{host.contact_phone}}</span>
          </p>
        </span>
      </template>
      <template v-else-if="selected_section==='work_section_1'">
        <div class="mc1inlineContent" id='work_section_1'>
            <div data-packed="true" class="txtNew">
                <h1 class="font_2" style="text-align:center; line-height:1.55em;">
                  <span class="color_15">Вводная консультация</span>
                </h1>
            </div>
            <div data-packed="true" class="txtNew">
                <p class="font_1" style="text-align:center; line-height:1.5em;">
                  <span class="color_15">
                    <span style="font-weight:bold;">Вы оставляете заявку на сайте и мы Вам перезвоним в течение 5 минут</span>
                  </span>
                </p>
            </div>
            <div>
              <img :src="host.img_work_section_1" alt="" class="slide-img">
            </div>
            <div data-packed="true" class="txtNew">
              <p class="font_9 work-concept-text">
                <span class="color_15">{{host.text_work_section_1}}</span>
              </p>
            </div>
            <div class="nav-links">
              <a class="nav-link" href="#" @click="selected_section='main'">
                <i class="fa fa-arrow-left"></i>
                на главную</a>
              <a class="nav-link" href="#" @click="selected_section='work_section_2'">читать дальше
                <i class="fa fa-arrow-right"></i>
              </a>
            </div>
        </div>
      </template>
      <template v-else-if="selected_section==='work_section_2'">
        <div class="mc1inlineContent" id='work_section_2'>
            <div data-packed="true" class="txtNew">
              <h1 class="font_2" style="text-align:center; line-height:1.55em;">
                <span class="color_15">Создание личного кабинета клиента</span>
              </h1>
            </div>
            <div>
              <img :src="host.img_work_section_2" alt="" class="slide-img">
            </div>
            <div data-packed="true" class="txtNew">
              <p class="font_9 work-concept-text">
                <span class="color_15" v-html="host.text_work_section_2"></span>
              </p>
            </div>
            <div class="nav-links">
              <a class="nav-link" href="#" @click="selected_section='work_section_1'">
                <i class="fa fa-arrow-left"></i>
                назад</a>
              <a class="nav-link" href="#" @click="selected_section='work_section_3'">читать дальше
                <i class="fa fa-arrow-right"></i>
              </a>
            </div>
        </div>
      </template>
      <template v-else-if="selected_section==='work_section_3'">
        <div class="mc1inlineContent" id='work_section_3'>
            <div data-packed="true" class="txtNew">
              <h1 class="font_2" style="text-align:center; line-height:1.55em;">
                <span class="color_15">Ваш личный юрист решает Вашу проблему</span>
              </h1>
            </div>
            <div>
              <img :src="host.img_work_section_3" alt="" class="slide-img">
            </div>
            <div data-packed="true" class="txtNew">
              <p class="font_9 work-concept-text">
                <span class="color_15">{{host.text_work_section_3}}</span>
              </p>
            </div>
            <div class="nav-links">
              <a class="nav-link" href="#" @click="selected_section='work_section_2'">
                <i class="fa fa-arrow-left"></i>
                назад</a>
              <a class="nav-link" href="#" @click="selected_section='id-online-record'">онлайн-запись
                <i class="fa fa-arrow-right"></i>
              </a>
            </div>
        </div>
      </template>
      <div v-else-if="selected_section==='id-online-record'" class="online-record-container">
        <template v-if="onlineRecordData.success == false">
        <div class="input_with-validation-indication" data-disabled="false" id="id-online-record">
          <label for="rec-name-input" id="comp-k9ixnv6wlabel" class="for-input-label"></label>
          <input type="text" required="" placeholder="Имя" maxlength="100" class="has-custom-focus input-box-style" id="rec-name-input" v-model="onlineRecordData.name">
          <p id="comp-k9ixnv6wmessage" class="style-k9ixnvvn1message" style="display: none;"></p>
        </div>
        <div class="input_with-validation-indication" data-disabled="false" id="id-online-record">
          <label for="rec-phone-input" id="comp-k9ixnv6wlabel" class="for-input-label"></label>
          <masked-input type="text" required="" placeholder="Контактный телефон" maxlength="16"
          mask="\+\7 (111) 111-1111"
          class="has-custom-focus input-box-style" id="rec-phone-input" v-model="onlineRecordData.phoneNumber"/>
          <p id="comp-k9ixnv6wmessage" class="style-k9ixnvvn1message" style="display: none;"></p>
        </div>
        <div class="input_with-validation-indication" data-state="valid" id="comp-k9ixnv7j1" style="height: 151px; margin-bottom: 0">
          <label for="rec-text-input" id="comp-k9ixnv7j1label" class="for-input-label"></label>
          <textarea placeholder="Содержание вопроса (не более 500 символов)" class="has-custom-focus texta-box-style" id="rec-text-input" v-model="onlineRecordData.text"></textarea>
        </div>
        <div class="agreement">
          <input type="checkbox" class="has-custom-focus" name="rec-processing-pers-data-input" id="rec-processing-pers-data-input"
          style="margin-right: 1rem;"
          v-model="onlineRecordData.agreeProcessingPersonalData">
          <label class="agree-input-text" for="rec-processing-pers-data-input">Я соглашаюсь с Политикой обработки персональных данных и даю согласие на обработку персональных данных
            <p class="agreement-link" @click="selected_section='read-personal-agreenmnet'">(читать Политику обработки персональных данных)</p></label><br>
        </div>
        <div v-if="onlineRecordFormComplete">
          <button class="font_10" @click="onClickCreateOnlineRecord">Отправить</button>
        </div>
        </template>
        <div v-else-if="onlineRecordData.success == true" class="success-record">
          <div class="dummy-positioning">
            <div class="success-icon">
              <div class="success-icon__tip"></div>
              <div class="success-icon__long"></div>
            </div>
          </div>
          <label>Спасибо за Ваше обращение. Ожидайте ответ в течении 30 минут.</label>
        </div>
      </div>
      <div v-else-if="selected_section==='id-payment'" class="payment-container">
        <label>
          <h3>Услуги компании {{host.company}} подлежат оплате:</h3>
          1. из <a href="https://client.urikoff.ru" target="_self" class="cabinet-link">личного кабинета</a> с использованием банковских карт<br>
          2. безналичным расчётом<br>
        </label>
        <label style="margin-top: 1em; display: block;">
          Оплата юридических услуг производится в размере и порядке, предусмотренном в <u>договоре оказания юридических услуг</u>.
        </label>
        <div>
          <div class="col-12">
            <h3>Способ оплаты №1: Банковской картой</h3>
            <p>
              Оплата происходит через ПАО СБЕРБАНК с использованием банковских
              карт следующих платёжных систем:
            </p>
            <ul class="list-group">
            <li class="list-group-item">
              <span>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Mir-logo.svg/2000px-Mir-logo.svg.png"
                  width="120"
                  style="margin-top: 5px"
                  alt="МИР"
                />
              </span>
            </li>
            <li class="list-group-item">
              <span>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png"
                  width="120"
                  style="margin-top: 5px"
                  alt="VISA"
                />
              </span>
            </li>
            <li class="list-group-item">
              <span>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                  width="100"
                  alt="Mastercard"
                />
              </span>
            </li>
              <!-- <li class="list-group-item">
                  <span>
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Maestro_logo.png/640px-Maestro_logo.png" width="70" style="margin-top:5px" alt="">
                      Maestro
                  </span>
                  </li> -->
              </ul>
          </div>

          <div class="col-12">
            <h3>Возврат средств</h3>
            <p>
              Возврат переведенных средств, производится на Ваш банковский
              счет в течение 5—30 рабочих дней (срок зависит от Банка, который
              выдал Вашу банковскую карту).
            </p>
          </div>

          <div class="col-12">
            <h3>Описание процесса передачи данных</h3>
            <p>
              Для оплаты (ввода реквизитов Вашей карты) Вы будете
              перенаправлены на платежный шлюз ПАО СБЕРБАНК. Соединение с
              платежным шлюзом и передача информации осуществляется в
              защищенном режиме с использованием протокола шифрования SSL. В
              случае если Ваш банк поддерживает технологию безопасного
              проведения интернет-платежей Verified By Visa или MasterCard
              SecureCode для проведения платежа также может потребоваться ввод
              специального пароля. Настоящий сайт поддерживает 256-битное
              шифрование. Конфиденциальность сообщаемой персональной
              информации обеспечивается ПАО СБЕРБАНК. Введенная информация не
              будет предоставлена третьим лицам за исключением случаев,
              предусмотренных законодательством РФ. Проведение платежей по
              банковским картам осуществляется в строгом соответствии с
              требованиями платежных систем МИР, Visa Int. и MasterCard Europe
              Sprl.
            </p>
          </div>
          <div class="col-12">
            <h3>Действия при возникновении проблем с оплатой:</h3>
            <p>
            При возникновении проблем с оплатой Клиенту необходимо немедленно обратиться к ответственному юристу
            по его делу в чат в <a href="https://client.urikoff.ru" target="_self" class="cabinet-link">личном кабинете</a> или по телефону: {{host.contact_phone}}
            </p>
          </div>
          <div class="col-12">
              <h3>Реквизиты</h3>
              <p>
              Наименование: <b>{{ requisites.payment_info.fullName }}</b>
              </p>
              <p>
              Сокращенно: <b>{{ requisites.payment_info.shortName }}</b>
              </p>
              <p>
              Английское: <b>{{ requisites.payment_info.internationName }}</b>
              </p>
              <p>
              Сокращенно: <b>{{ requisites.payment_info.shortInternationName }}</b>
              </p>
              <p>
              ИНН: <b>{{ requisites.payment_info.inn }}</b>
              </p>
              <p>
              КПП: <b>{{ requisites.payment_info.kpp }}</b>
              </p>
              <p>
              ОГРН: <b>{{ requisites.payment_info.ogrn }}</b>
              </p>
              <p>
              Расчетный счет: <b>{{ requisites.payment_info.checkingAccount }}</b>
              </p>
              <p>
              Наименование банка: <b>{{ requisites.payment_info.bankName }}</b>
              </p>
              <p>
              БИК: <b>{{ requisites.payment_info.bik }}</b>
              </p>
              <p>
              Кор. Счет: <b>{{ requisites.payment_info.corporateAccount }}</b>
              </p>
          </div>
        </div>
        <span class="pay-section-label" style="text-align: center; margin-top: 1.5em">Юридические услуги*</span>
        <table class="usligi-table">
          <tbody>
            <tr v-for="(rec, index) in requisites.uslugi" :key="index">
              <td>{{rec.text}}</td>
              <td>{{rec.price}}</td>
            </tr>
          </tbody>
        </table>
        <span style="display: block; margin-top: 1em">* указана ориентировочная стоимость, которая уточняется в каждом конкретном случае в зависимости от сложности и объема работы</span>
      </div>
      <template v-if="selected_section=='read-personal-agreenmnet'">
        <div class="mc1inlineContent" id='read-personal-agreenmnet'>
          <div class="agreement-block">
            <b style="margin-bottom: 1em; display: block; font-weight: 400;">
              <i class="fa fa-arrow-left" style="cursor: pointer" @click="selected_section='id-online-record'"></i>
              СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
            </b>
            <label>
            <!-- eslint-disable-next-line -->
            В соответствии с Федеральным законом от 27.07.06 № 152-ФЗ «О персональных данных» выражаю согласие Обществу с ограниченной ответственностью «Юрикофф» (ИНН 4703177344, местонахождение: 188669, ОБЛАСТЬ ЛЕНИНГРАДСКАЯ, РАЙОН ВСЕВОЛОЖСКИЙ, ГОРОД МУРИНО, АЛЛЕЯ ОХТИНСКАЯ, ДОМ 14, КВАРТИРА 1116 (далее – Компания) на осуществление со всеми персональными данными, указанными мною при заполнении формы регистрации на сайте Компании, а также представленными мною в процессе заключения или исполнения/продления договора оказания услуг, заключаемого с Компанией, документах, следующих действий: сбор, систематизация, накопление, хранение, в том числе в электронном виде, уточнение (обновление, изменение), перевозка, использование, распространение (включая передачу), обезличивание, блокирование, уничтожение (далее – обработка), в целях заключения, исполнения, продления и прекращения договора оказания услуг, заключаемого с Компанией, защиты конфиденциальной информации (в том числе персональных данных), осуществления хранения конфиденциальной информации, в том числе в электронном виде, а также в целях продвижения на рынке услуг (товаров, работ) Компании путем осуществления со мною прямых контактов посредством использования телефонной, факсимильной, подвижной радиотелефонной связи, электронных средств связи (включая SMS-сообщения), а также почтовой и других средств связи.
Обработка персональных данных осуществляется Компанией на бумажных и электронных носителях с использованием и без использования средств автоматизации.
Настоящее согласие действует бессрочно с момента предоставления и прекращается по моему письменному заявлению (отзыву), согласие может быть отозвано при условии письменного уведомления Компании.
Я поручаю Компании (в том числе в лице их уполномоченных работников и иных привлекаемых ими лиц), осуществлять обработку персональных данных с соблюдением принципов и правил обработки персональных данных, предусмотренных Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», с соблюдением конфиденциальности персональных данных и обеспечением безопасности персональных данных при их обработке, на безвозмездной основе.
Требования к защите обрабатываемых персональных данных, в т.ч. необходимые правовые, организационные и технические меры по защите персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения и иных неправомерных действий в отношении персональных данных определяются Компанией самостоятельно с учетом требований Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».
            </label>
          </div>
            <div class="nav-links nav-back">
              <a class="nav-link" href="#" @click="agreeProcessingPersonalData()">
                <i class="fa fa-arrow-left"></i>
                я ознакомился
              </a>
            </div>
        </div>
      </template>
      <div data-packed="true" class="txtNew">
        <p class="font_10 unselectable copyright-text">
          <span class="color_15">Санкт‑Петербург и Ленинградская обл.</span>
          <br>
          <span class="color_15">{{host.copyright}}</span>
        </p>
      </div>
      <!-- <vue-cookie-accept-decline :debug="true" :position="'bottom'" :transitionName="'slideFromBottom'"
          @status="cookieStatus"
          @clickedAccept="cookieClickedAccept"
          @clickedDecline="cookieClickedDecline">
          <div slot="message">
              We use cookies to ensure you get the best experience on our website.
              <a href="https://cookiesandyou.com/" target="_blank">Learn More...</a>
          </div>
        </vue-cookie-accept-decline> -->
    </div>
</template>
<script>

import { Carousel, Slide } from 'vue-carousel'
import host from '../host.js'
import $ from 'jquery'
import VueCookies from 'vue-cookies'
import MaskedInput from 'vue-masked-input'
import requisites from '../data/requisites'

export default {
  name: 'Landing',
  components: {
    Carousel,
    Slide,
    MaskedInput
  },
  data () {
    return {
      title: host.company_short,
      host: host,
      requisites,
      selected_section: 'main',
      onlineRecordData: {
        phoneNumber: '',
        name: '',
        text: '',
        agreeProcessingPersonalData: false,
        sendingData: false,
        success: false
      }
    }
  },
  computed: {
    onlineRecordFormComplete () {
      return this.onlineRecordData.phoneNumber.length === 17 &&
       this.onlineRecordData.name.length > 4 &&
       this.onlineRecordData.text.length > 16 &&
       this.onlineRecordData.agreeProcessingPersonalData === true
    }
  },
  methods: {
    agreeProcessingPersonalData () {
      this.selected_section = 'id-online-record'
      if (this.onlineRecordData) {
        this.onlineRecordData.agreeProcessingPersonalData = true
      }
    },
    onClickCreateOnlineRecord () {
      this.onlineRecordData.sendingData = true
      let number = this.onlineRecordData.phoneNumber.replace('(', '').replace(')', '').replace('-', '').replace('+', '').replace(/ /g, '')
      this.$http.post(`${host.host}/landing/create-appeal`,
        {
          name: this.onlineRecordData.name,
          contactPhone: `${number}`,
          message: this.onlineRecordData.text
        },
        {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: 'application/json'
          }
        })
        .then(
          (response) => {
            this.onlineRecordData.sendingData = false
            this.onlineRecordData.success = true
          },
          (response) => {
            this.onlineRecordData.sendingData = false
            // return toastr.error(response.body.message)
          }
        )
    }
  },
  created () {
    document.title = this.title
  },
  mounted () {
    $(document).ready(function () {
      if (!VueCookies.get('cook_banner')) {
        window.setTimeout(function () {
          $('.banner').css('display', 'block')
          $('.cookie-confirmation-button').click(function () {
            $('.banner').css('display', 'none')
            VueCookies.set('cook_banner', true, host.cookie_agree_life_time)
          })
        }, 3000)
      }
    })
  }
}
</script>
<style scoped>

.page-style {
  background-color: white;
  color:black;
  /* padding-left: 50px;
  padding-right: 50px; */
}

.VueCarousel-slide {
  position: relative;
  color: #fff;
  font-family: Arial;
  font-size: 24px;
  text-align: center;
  min-height: 100px;
}

.OfferingInfo207476195--verticalLayout {
  margin-left: 2rem;
  margin-right: 2rem;
}

.Grid3915352077--item {
  padding-bottom: 1rem;
  cursor: pointer;
  /* border: 1px solid black; */
}

.OfferingViewImage503669351--imageWrapper {
  width: 100%;
  background: black;
}

/* .Grid3915352077--item > *:hover {
  transform: scale(1.05);
  opacity: 1;
} */

.grid-image {
  margin-bottom: -4px;
}

.grid-image:hover {
  opacity: 0.75;
}

.dummy-positioning {
  /* width: 100%;
  height: 100vh; */
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue